import styled from 'styled-components';

import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { spacing16, spacing4 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';

export const ComponentTag = styled(BadgeSmallStyled)`
  display: inline-flex;
  align-items: center;
  position: absolute;
  left: ${rem(spacing16)};
  top: ${rem(spacing16)};

  span {
    margin-left: ${rem(spacing4)};
  }
`;
